import {
  FocusLock,
  PlacementWithLogical,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import cn from 'classnames';
import React from 'react';

import { ReactComponent as TriangleDown } from '@/app/_icons/triangle-down.svg';
import { useIsMobile } from '@/utils/useIsMobile';

import FilterBadge from '../../../search/filter-badge/filter-badge';

import styles from './new-filter.module.scss';

export const NewFilter: React.FC<{
  children: React.ReactNode;
  label: string;
  count?: number;
  onClose?: () => void;
  onClear?: () => void;
  placement?: PlacementWithLogical;
}> = ({ children, label, onClose, count, onClear, placement = 'bottom' }) => {
  const isMobile = useIsMobile();

  return (
    <Popover
      isLazy
      onClose={onClose}
      placement={placement}
      preventOverflow
      returnFocusOnClose
      closeOnBlur={true}
    >
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <div
              className={cn(styles.filterInput, {
                [styles.filterInputActive as string]: isOpen,
              })}
            >
              {label}
              <TriangleDown className={styles.filterTriangle} />
              <FilterBadge count={count} onClear={onClear} />
            </div>
          </PopoverTrigger>
          <PopoverContent
            minWidth={350}
            className={cn(styles.filterContent, styles.full)}
            paddingTop={{
              base: 6,
              sm: 0,
            }}
          >
            <FocusLock persistentFocus={true} isDisabled={isMobile}>
              <PopoverCloseButton />
              <PopoverBody>{children}</PopoverBody>
            </FocusLock>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};
